import React from "react";
import performanceStatsImg1 from "../../../../assets/performanceStats1.png";
import performanceStatsImg2 from "../../../../assets/performanceStats2.png";
import performanceStatsImg3 from "../../../../assets/performanceStats3.png";
import performanceStatsImg4 from "../../../../assets/performanceStats4.png";
import performanceStatsImg5 from "../../../../assets/performanceStats5.png";
import performanceStatsImg6 from "../../../../assets/performanceStats6.png";
import performanceStatsImg7 from "../../../../assets/topSteal.png";
import performanceStatsImg8 from "../../../../assets/topBlock.png";
import officials from "../../../../assets/officials.png";

import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

const PerformanceStats = () => {
  const playersReducer = useSelector((state) => state?.playersReducer);
  const matchData = playersReducer?.matchData;
  const eventId = localStorage.getItem('eventID');

  const performanceStatsData = [
    {
      _id: "01",
      design: "Rotating Team Performance Summary",
      title: "Web overlay",
      image: performanceStatsImg2,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/2.html?id=`,
    },
    {
      _id: "02",
      design: "Top Efficiencies",
      title: "Web overlay",
      image: performanceStatsImg3,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/3.html?id=`,
    },
    {
      _id: "03",
      design: "Top Score",
      title: "Web overlay",
      image: performanceStatsImg4,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/4.html?id=`,
    },
    {
      _id: "04",
      design: "Top Assist",
      title: "Web overlay",
      image: performanceStatsImg5,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/5.html?id=`,
    },
    {
      _id: "05",
      design: "Top Rebound",
      title: "Web overlay",
      image: performanceStatsImg6,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/6.html?id=`,
    },
    {
      _id: "06",
      design: "Top Steal",
      title: "Web overlay",
      image: performanceStatsImg7,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/topSteal.html?id=`,
    },
    {
      _id: '07',
      design: "Top Block",
      title: 'Web overlay',
      image: performanceStatsImg8,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/topBlock.html?id=`
    },
    // {
    //   _id: "08",
    //   design: "Officials",
    //   title: "Web overlay",
    //   image: officials,

    //   link: `${process.env.REACT_APP_OL_API_ROOT}`+`/o/s/8.html?id=`,
    // }
  ];

  const handleCopyClick = (link, id) => {
    const textarea = document.createElement('textarea');
    textarea.value = link + id;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    toast.success('Copied to clipboard!');
  };

  const selectEvent = useSelector((state) => state?.settingReducer?.selectEvent);
  const selectedGroupCodes = JSON.parse(localStorage.getItem('selectedGroupCodes'));
  const selectedEventsOptions = localStorage.getItem("selectedEventsOptions");
  const eventsOptions = JSON.parse(selectedEventsOptions);

  const eventTitle = (id) => {
    const event = eventsOptions.find((data) => data.value.split(" ")[0] === id);
    return event ? event.label : null;
  };

  return (
    <div>
      <div>
        {
          selectedGroupCodes && selectedGroupCodes.length && selectedGroupCodes.map((groupCode) => (
            <div key={groupCode} className='flex flex-col gap-6 relative'>
              <h2 className='pt-5 text-left font-bebas text-2xl pl-2'>
                Group Code: {groupCode}
              </h2>
              {
                eventsOptions[groupCode] && eventsOptions[groupCode].length && eventsOptions[groupCode].slice().reverse().map((event, index) =>
                  <div className="flex flex-col gap-6" key={index}>
                    <h2 className='pt-5 text-left font-bebas text-2xl pl-2'>
                      {event.label} {/* Render the correct event property */}
                    </h2>
                    {performanceStatsData.map((data, i) => (
                      <div key={i} className="border-[1px] border-[#E8E8E8] rounded-md flex flex-col md:flex-row justify-between items-center">
                        <div className="border-r-[1px] border-[#E8E8E8] max-w-[675px] w-full">
                          <p className="font-bebas text-[#4A4A4A] text-2xl py-4 px-6">
                            {data?.design}
                          </p>
                          <div className="py-4 px-6 flex flex-col gap-2 border-t-[1px] border-[#E8E8E8]">
                            <p className="font-bebas block text-[#4A4A4A] text-2xl ">
                              {data?.title}
                            </p>
                            <p className="text-[#2F2B77] block font-montserrat font-medium text-base break-all">
                              {data.link}{event.eventCode} {/* Use eventCode instead of the entire event object */}
                            </p>
                            <button onClick={() => handleCopyClick(data.link, event.eventCode)} className="max-w-16 w-full h-8 rounded bg-primary flex justify-center items-center text-white font-bebas">
                              copy
                            </button>
                          </div>
                        </div>
                        <div className="flex justify-center items-center max-w-full md:max-w-[480px] w-full py-[18px] md:py-0 border-t-[1px] border-[#E8E8E8] md:border-none">
                          {
                            data?.image && <img
                              className="max-w-[240px] w-full h-[172px] object-contain rounded-md"
                              src={data?.image}
                              alt="scoreboardImg"
                            />
                          }
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default PerformanceStats;
